import consumer from "./consumer"

// Player channel for notifications and invitations
let playerChannelSubscription = null;

function initializePlayerChannel() {
  // Get player ID from meta tag or session
  const playerIdMeta = document.querySelector('meta[name="player-id"]');
  const playerId = playerIdMeta ? playerIdMeta.getAttribute('content') : null;
  
  if (!playerId) {
    console.log('No player ID found, skipping player channel subscription');
    return;
  }
  
  // Unsubscribe from existing channel if any
  if (playerChannelSubscription) {
    consumer.subscriptions.remove(playerChannelSubscription);
  }
  
  // Subscribe to player channel
  playerChannelSubscription = consumer.subscriptions.create({
    channel: "PlayerChannel", 
    player_id: playerId
  }, {
    connected() {
      console.log(`Connected to player channel for player ${playerId}`);
    },
    
    disconnected() {
      console.log(`Disconnected from player channel for player ${playerId}`);
    },
    
    received(data) {
      console.log("Player channel received:", data);
      handlePlayerNotification(data);
    }
  });
}

function handlePlayerNotification(data) {
  const { type, message } = data;
  
  switch(type) {
    case 'game_invitation':
      handleGameInvitation(data);
      break;
    case 'game_started':
      handleGameStarted(data);
      break;
    case 'player_removed':
      handlePlayerRemoved(data);
      break;
    case 'game_finished':
      handleGameFinished(data);
      break;
    default:
      // Show general notification
      showNotification(message || 'You have a new notification', 'info');
      // Refresh the side menu to show updated invitations
      refreshSideMenu();
  }
}

function handleGameInvitation(data) {
  const { game_id, inviter_name, message } = data;
  
  // Show notification
  showNotification(`${inviter_name} invited you to play Matatu!`, 'invitation');
  
  // Refresh side menu to show new invitation
  refreshSideMenu();
  
  // Optional: Play notification sound
  playNotificationSound();
}

function handleGameStarted(data) {
  const { game_id, message } = data;
  
  // Show notification
  showNotification(message || 'Your game has started!', 'success');
  
  // Don't call updategame here - the 'game_state_change' notification will handle the update
  // This prevents double updates that cause menu visibility issues
  console.log('Game started notification received - game state will be updated by separate game_state_change notification');
}

function handlePlayerRemoved(data) {
  const { game_id, message } = data;
  
  // Show notification
  showNotification(message || 'You have been removed from the game', 'warning');
  
  // Refresh the page
  setTimeout(() => {
    window.location.reload();
  }, 1500);
}

function handleGameFinished(data) {
  const { game_id, winner_name, message } = data;
  
  // Show notification
  showNotification(message || `Game finished! Winner: ${winner_name}`, 'success');
  
  // Refresh side menu
  refreshSideMenu();
}

function showNotification(message, type = 'info') {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `notification notification--${type} notification--show`;
  notification.innerHTML = `
    <div class="notification-content">
      <span class="notification-message">${message}</span>
      <button class="notification-close" onclick="this.parentElement.parentElement.remove()">×</button>
    </div>
  `;
  
  // Add to page
  document.body.appendChild(notification);
  
  // Auto-remove after 5 seconds
  setTimeout(() => {
    if (notification.parentElement) {
      notification.classList.remove('notification--show');
      setTimeout(() => notification.remove(), 300);
    }
  }, 5000);
}

function refreshSideMenu() {
  // Refresh the side menu via AJAX
  $.ajax({
    url: "/web/updategame",
    data: {},
    dataType: "script"
  }).done(function() {
    console.log('Side menu refreshed');
  }).fail(function(xhr, status, error) {
    console.error('Failed to refresh side menu:', error);
  });
}

function playNotificationSound() {
  // Optional: Play a notification sound
  try {
    const audio = new Audio('/sounds/notification.mp3');
    audio.volume = 0.3;
    audio.play().catch(e => {
      console.log('Could not play notification sound:', e);
    });
  } catch (e) {
    console.log('Notification sound not available');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializePlayerChannel);

// Reinitialize on page navigation (for Turbolinks)
document.addEventListener('turbolinks:load', initializePlayerChannel);

// Export for global access
window.initializePlayerChannel = initializePlayerChannel;